var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:date-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.41699 6.37499C1.41699 5.03907 1.41699 4.37182 1.83208 3.95674C2.24716 3.54166 2.91441 3.54166 4.25033 3.54166H12.7503C14.0862 3.54166 14.7535 3.54166 15.1686 3.95674C15.5837 4.37182 15.5837 5.03907 15.5837 6.37499C15.5837 6.70861 15.5837 6.87578 15.4802 6.97991C15.3761 7.08332 15.2082 7.08332 14.8753 7.08332H2.12533C1.7917 7.08332 1.62453 7.08332 1.52041 6.97991C1.41699 6.87578 1.41699 6.70791 1.41699 6.37499ZM1.41699 12.75C1.41699 14.0859 1.41699 14.7532 1.83208 15.1682C2.24716 15.5833 2.91441 15.5833 4.25033 15.5833H12.7503C14.0862 15.5833 14.7535 15.5833 15.1686 15.1682C15.5837 14.7532 15.5837 14.0859 15.5837 12.75V9.20832C15.5837 8.8747 15.5837 8.70753 15.4802 8.60341C15.3761 8.49999 15.2082 8.49999 14.8753 8.49999H2.12533C1.7917 8.49999 1.62453 8.49999 1.52041 8.60341C1.41699 8.70753 1.41699 8.87541 1.41699 9.20832V12.75Z",
    fill: "#27346A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.95898 2.125V4.25M12.0423 2.125V4.25",
    stroke: "#27346A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.fa8c8fab05a8a7c7770ac78ae237d30c.svg";
export { ForwardRef as ReactComponent };